export default (obj) => (obj ? Object.keys(obj).length !== 0 : false)
